export enum LLMProvider {
  AzureOpenAI = 'AzureOpenAI',
  Claude = 'Claude',
  Deepseek = 'Deepseek',
  OpenAI = 'OpenAI',
  OpenRouter = 'OpenRouter'
}

export const LLMProviderNames: { id: LLMProvider; name: string }[] = [
  { id: LLMProvider.OpenAI, name: 'OpenAI' },
  { id: LLMProvider.AzureOpenAI, name: 'Azure OpenAI' },
  { id: LLMProvider.OpenRouter, name: 'OpenRouter' },
  { id: LLMProvider.Deepseek, name: 'Deepseek' },
  { id: LLMProvider.Claude, name: 'Claude' }
];

export interface LLMProviderSettings {
  id: string;
  provider: LLMProvider;
  token: string;
  baseUrl: string;
  defaultChatModel: string;
  defaultEmbeddingModel: string;
  isDefault: boolean;
  isEmbeddingProvider: boolean;
}

export interface LLMCustomerAccess {
  id: string;
  customerId: string;
  customerName: string;
  provider: LLMProvider;
  baseUrl: string;
  isDefault: boolean;
}

export interface LLMSelectableProvider {
  id: string;
  provider: LLMProvider;
  baseUrl: string;
  hasSystemToken: boolean;
}

export interface LLMMyAccess {
  id: string;
  providerId: string;
  provider?: LLMProvider;
  token: string;
  baseUrl: string;
  isDefault: boolean;
}

export interface LLMConnectionTestResult {
  success: boolean;
  error: string;
  models: string[];
  note: string;
}

export interface LLMUsagePoint {
  day: string;
  requests: number;
  spend: number;
}

export interface LLMUsageByProvider {
  provider: LLMProvider;
  requests: number;
  spend: number;
}

export interface LLMUsageByCustomer {
  customerName: string;
  requests: number;
  spend: number;
  ownCredentials: boolean;
}

export interface LLMUsageSummary {
  totalRequests: number;
  totalSpend: number;
  failureRate: number;
  ownCredentialShare: number;
  perDay: LLMUsagePoint[];
  perProvider: LLMUsageByProvider[];
  topCustomers: LLMUsageByCustomer[];
}
